<template>
  <div class="saved-card">
    <div v-if="!hideTitle" class="title">{{card.title}}</div>
    <div class="icons"><slot/></div>
    <div class="ccard" v-if="isCardOwner">
      <div class="card-brand">
        <img v-if="card.brand == 'Visa'" class="svg" src="/static/images/creditcards/visa.svg">
        <img v-if="card.brand == 'MasterCard'" class="svg" src="/static/images/creditcards/mastercard.svg">
        <img v-if="card.brand == 'American Express'" class="svg" src="/static/images/creditcards/amex.svg">
        <img v-if="card.brand == 'Discover'" class="svg" src="/static/images/creditcards/discover.svg">
      </div>
      <div class="card-info">
        <div class="card-name">{{card.name}}</div>
        <div><span>**** **** ****</span> {{card.last4}}</div>
        <div>Expires: {{card.exp_month}}/{{card.exp_year}}</div>
      </div>
    </div>
    <div v-else>
      <small>This is a shared card owned by {{ownerName}}</small>
    </div>
  </div>

</template>

<style lang="scss" scoped>

.ccard {
  display: flex;
  flex-flow: row nowrap;

  .card-info {
    font-size: smaller;
  }
}


.saved-card {
  position: relative;
  padding: 1em 1.5em 1em 0.5em ;

  .icons {
    position: absolute;
    display: flex;
    flex-flow: column nowrap;
    right: 0em;
    top: 1em;
  }
}
span{
  letter-spacing: 2px;
}

.title {
  font-weight: bold;
}

.card-brand{
  margin-right: 0.5em;
  & .svg{
    height: 30px;
     width:48px;
  }
}
</style>

<script>
import { mapGetters } from 'vuex';

export default {
  props: {card: Object, hideTitle: Boolean},
  computed: {
    ...mapGetters(['user']),
    isCardOwner() {
      return this.user.id === this.card.owner.id;
    },
    ownerName() {
      let owner = this.card.owner;
      return owner ? (owner.first_name + ' ' + owner.last_name) : 'another person on your team';
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/dashboard/settings/billing/SavedCard.vue